import React from 'react';

interface IProps {
  children: React.ReactElement[] | React.ReactElement;
}

export const FormFieldGroup = ({ children }: IProps) => {
  return <div className="form-field-group">{children}</div>;
};
